import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AProgessBarWizardComponent } from '../../../components/common/progressbarwizard/iprogressbar.wizard.component';
import { ProgressBarWizardEvents } from '../../../components/common/progressbarwizard/progressbar.wizard.events';
import { ResourceBase } from '../../../models/enums/resourcebase.enum';
import { DataModelService, DataSourceQuery } from '../../../services/datamodel.service';
import { SmartSyncService } from '../../../services/smart.sync.service';

@Component({
    selector: 'siw-target-page',
    templateUrl: './siw.target.page.html',
    styleUrls: ['./siw.target.page.css']
})
export class SmartIntegrationWizardTargetPage extends AProgessBarWizardComponent implements OnInit {
    WizardState: any = {};
    DataSources = [];
    TableExisting = false;
    CanStepForwardValue = false;

    get CanStepForward(): boolean {
        return this.CanStepForwardValue;
    }

    constructor(private cdRef: ChangeDetectorRef, private service: SmartSyncService, private dmService: DataModelService) {
        super();
    }

    ngOnInit(): void {
        const query = new DataSourceQuery(null);
        query.DBUsages = [[8192, 16.384], [32.768]]; // (RelationalWrite or RelationalBulk) and (RelationalCreateStructure)
        query.ResourceBase = ResourceBase.Database;
        this.dmService.GetDataSourcesByQuery(query).subscribe((x: any[]) => {
            if (x) {
                this.DataSources = x;
                this.cdRef.detectChanges();
            }
        });
    }

    UpdateWizardState(): void {
        this.WizardState.SelectedTargetCaption = null;
        if (this.WizardState && this.WizardState.SelectedTarget) {
            const ds = this.DataSources.find((x: any) => x.SID == this.WizardState.SelectedTarget);
            if (ds) {
                this.WizardState.SelectedTargetCaption = ds.Caption;
            }
        }
    }

    OnWizardStateSet(): void {
        this.checkCanStepForward();
    }

    onTargetNameChanged() {
        if (this.WizardState && this.WizardState.TargetTableName) {
            this.WizardState.TargetTableName = this.WizardState.TargetTableName.replace(/[\W]/gi, '');
        }
        this.checkCanStepForward();
    }

    checkCanStepForward() {
        this.CanStepForwardValue = false;
        this.TableExisting = false;
        if (this.WizardState && this.WizardState.SelectedTarget && this.WizardState.TargetTableName) {
            this.service.CheckExistsTable(this.WizardState.SelectedTarget, this.WizardState.TargetTableName).subscribe(x => {
                if (x == true) {
                    this.TableExisting = true;
                } else {
                    this.CanStepForwardValue = true;
                }
                ProgressBarWizardEvents.DetectChanges.next();
            });
        }
    }
}
